import styled from 'styled-components'
import {Link as LinkS} from 'react-scroll'

export const NavCon = styled.nav`
    background: ${({ scrollNav}) => (scrollNav ? '#060C22' : 'transparent')};
    display: flex;
    height: 80px;
    justify-content: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;
    transition: 0.8s all ease;

    @media screen and (max-width: 860px) {
        transition: 0.8s all ease;
    }
`

export const NavBarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1400px;

    @media screen and (max-width: 860px){
        max-width: 860px;
    }
`

export const NavLogo = styled(LinkS)`
    color: #fff;
    height: 80px;
    cursor: pointer; 
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    font-weight: bold;
    text-decoration: none;
`

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 860px){
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 70%);
        font-size: 1.8rem;
        cursor: pointer;
        color: #fff;
    }
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;

    @media screen and (max-width: 860px){
        display:none;
    }
`

export const NavItem = styled.li`
    height: 80px;
    position: relative;
`

export const NavLinks = styled(LinkS)`
color: #fff;
display: flex;
align-items: center;
text-decoration: none;
padding: 0 1rem;
height: 100%;
cursor: pointer;

&.active:after{
    width: 100%; 
    left: 0; 
    opacity: 1;
}

&:after {    
    background: none repeat scroll 0 0 transparent;
    bottom: 10px;
    content: "";
    display: block;
    height: 2px;
    left: 50%;
    position: absolute;
    background: #1F94C2;
    transition: all 0.2s ease-in-out;
    transition-duration: 0.75s;
    width: 0;
    opacity: 0;
  }
  &:hover:after { 
    width: 100%; 
    left: 0; 
    opacity: 1;
  }
  `

export const NavBtn = styled.nav`
    display:flex;
    align-items: center;
    border-radius: 50px;
    color: white;
    background: transparent;
    border: 3px solid #1F94C2;

    @media screen and (max-width: 860px){
        display: none;
    }
`

export const NavBtnLink = styled(LinkS)`
    
    white-space: nowrap;
    padding: 5px 11px;
    color: white;
    font-size: 1rem;
    border-radius: 50px;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover{
        transition: all 0.2 ease-in-out;
        background: #1F94C2;
    }
`

